import {FC, SVGProps} from "react";

export const WindowsIcon: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 3H11V12H2V3ZM11 22H2V13H11V22ZM21 3V12H12V3H21ZM21 22H12V13H21V22Z" fill="#E9E9E9"/>
    </svg>
  );
};